﻿
import Vue from "vue";
import './style.scss';

var previousAjax;
var nextCallback = null;

var basePath = window.app.base;
var instance = new Vue({
    data: {
        modalTitle: '',
        obveznikId: '',
        //columns: [{ name: "MatBr", title: "Maticni broj" }, { name: "Aop", title: "AOP" }],
        //rows: [{ MatBr: "123456", Aop: "123" }],
        columns: [],
        rows: [],
        selectedItem: {},
        searchForm: {
            typeText: "AOP",
            typeId: 0,
            modelText: "",
            modelSelect: 0
        }
    },
    methods: {
        setSearchType: function (id, type) {
            this.searchForm.typeId = id;
            this.searchForm.typeText = type;
            this.searchForm.modelText = "";
            this.searchForm.modelSelect = 0;

            this.columns = [];
            this.rows = [];
        },

        onInput: function () {
            var q = this.searchText;
            var c = this;

            var ajaxUrl = basePath+"IzvodiAjax/Zemljiste";
            var data = null;


            data = { obveznikId: this.obveznikId };
            previousAjax = $.ajax({
                url: ajaxUrl,
                method: "GET",
                data: data
            }).then(function (result) {
                c.columns = result.columns;
                for (var i = 0; i < result.rows.length; i++) {
                    result.rows[i]._isSelected = false;
                }
                c.rows = result.rows;

            }).fail(function () {
                // on fail .......
            });
        },

        selectItem: function (re) {
            for (var i = 0; i < this.rows.length; i++) {
                this.rows[i]._isSelected = false;
            }
            this.selectedItem = re;
            re._isSelected = true;
        },

        openPrompt: function (obveznikId, modalTitle, callback) {

            $(this.$el).modal('show');
            $(this.$el).find("input[type='text']").focus();

            this.modalTitle = modalTitle;
            this.obveznikId = obveznikId;
            nextCallback = callback;

            this.onInput();

            $(this.$el).on('hidden.bs.modal', function () {
                $("body").addClass("modal-open");
            });
        },

        cancel: function () {
            $(this.$el).modal('hide');

        },

        save: function () {
            var item = this.selectedItem;

            $(this.$el).modal('hide');

            nextCallback(item);
        }
    }
});


var component = {
    v: instance,
    name: "popup-reference-zemljiste"
};

export default component;